/**
 * EntityLinkView — React NodeView for the inline entityLink node ([[ ... ]]).
 *
 * Renders an entity-type icon + label as a clickable chip that opens the
 * entity preview modal (or navigates, for non-previewable types like tags).
 */

import { NodeViewWrapper, type NodeViewProps } from '@tiptap/react';
import { useEntityPreview } from '../../contexts/EntityPreviewContext';
import { getEntityIcon, getEntityColor, type EntityType } from '../EntityChip';

export function EntityLinkView({ node }: NodeViewProps) {
  const { entityType, entityId, label } = node.attrs as {
    entityType: EntityType; entityId: string; label: string;
  };
  const { openPreview } = useEntityPreview();
  const Icon = getEntityIcon(entityType);
  const color = getEntityColor(entityType);

  function handleClick(e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    if (entityType && entityId) openPreview(entityType, entityId, label);
  }

  return (
    <NodeViewWrapper as="span" className={`entity-link-node entity-link-${entityType}`}>
      <button type="button" className="entity-link-chip" onClick={handleClick}
        contentEditable={false} aria-label={`Open ${entityType}: ${label || 'linked item'}`}>
        <Icon size={12} style={{ color }} />
        <span className="entity-link-label">{label || 'Linked item'}</span>
      </button>
    </NodeViewWrapper>
  );
}
